import { useState, useEffect } from 'react';
import { FFFStorage } from '@fff-web/fff-utilities';
import { getNextBox } from '../services/box';

const nextBoxKey = 'current-box';

const cacheDurationInMs = 10 * 60 * 1000; //10 minutes

const getNextBoxFromStorage = () => {
  const currentBox = FFFStorage.getFromStorage({ key: nextBoxKey });
  if (currentBox) {
    return currentBox.seasonDisplay;
  }
  return '';
};

const useNextBox = () => {
  const [nextBox, setNextBox] = useState(getNextBoxFromStorage);

  useEffect(() => {
    const boxInCache = getNextBoxFromStorage();
    if (boxInCache) {
      setNextBox(boxInCache);
    } else {
      getNextBox().then((currentBox) => {
        const currentNextBox = currentBox ? currentBox.seasonDisplay : '';
        setNextBox(currentNextBox);
        FFFStorage.setToStorage({ key: nextBoxKey, value: currentBox, durationInMs: cacheDurationInMs });
      });
    }
  }, []);

  return nextBox;
};

export default useNextBox;
